var _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgItem(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.5538 8.88892L17.7781 8.88892C11.6416 8.88892 6.66699 13.8635 6.66699 20V33.3334C6.66699 39.4699 11.6416 44.4445 17.7781 44.4445H35.5399L36.0217 44.4338C41.9328 44.1764 46.6469 39.3078 46.6555 33.3366L46.6603 20.0223L46.667 19.9955C46.667 13.8577 41.6907 8.8832 35.5538 8.88892ZM35.558 13.3333L35.9495 13.3443C39.3179 13.5365 42.016 16.2337 42.2113 19.6037L42.2204 19.9267L42.218 19.9989L42.2112 33.3322C42.2058 37.0123 39.22 39.9966 35.5378 40L17.7781 40C14.0962 40 11.1115 37.0152 11.1115 33.3333V20C11.1115 16.3181 14.0962 13.3333 17.7781 13.3333L35.558 13.3333Z",
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.5401 10.8521C35.4118 9.74688 34.4725 8.88901 33.3328 8.88901C32.1055 8.88901 31.1106 9.88393 31.1106 11.1112V42.2223L31.1256 42.4815C31.2539 43.5867 32.1932 44.4446 33.3328 44.4446C34.5601 44.4446 35.5551 43.4496 35.5551 42.2223V11.1112L35.5401 10.8521ZM22.2068 10.8521C22.0785 9.74691 21.1392 8.88904 19.9996 8.88904C18.7723 8.88904 17.7773 9.88396 17.7773 11.1113V42.2224L17.7923 42.4815C17.9207 43.5867 18.8599 44.4446 19.9996 44.4446C21.2269 44.4446 22.2218 43.4497 22.2218 42.2224V11.1113L22.2068 10.8521Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgItem);
export default __webpack_public_path__ + "static/media/Item.052db1433c6706da9dc15f93f8ff2947.svg";
export { ForwardRef as ReactComponent };